import { WelcomeMessageInput } from "./WelcomeMessageInput";
import { SystemMessageInput } from "./SystemMessageInput";
import { RealtimeApiConfig } from "./RealtimeApiConfig";

export function RealtimeApiSettings() {
  return (
    <div className="space-y-4">
      <RealtimeApiConfig />
      <WelcomeMessageInput />
      <SystemMessageInput />
    </div>
  );
}
